// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"OnLeaveDialog_dialogTitle__1gIBi","button":"OnLeaveDialog_button__2th_T"};